import PropTypes from 'prop-types';

import { useAppSelector } from '@/redux';
import styles from './DayBox.module.scss';
import { URLS } from '@/constants/urls';

export const DayBox = ({ day, selected, onClick }) => {
  const locale = useAppSelector(({ root }) => root.storeConf.codeISO.toLowerCase());

  const dayNumber = (new Date(day.dayOfShipping)).toLocaleDateString(locale, { day: 'numeric' });
  const monthShortName = (new Date(day.dayOfShipping)).toLocaleDateString(locale, { month: 'short' });
  const fullDate = (new Date(day.dayOfShipping))
    .toLocaleDateString(locale, { day: '2-digit', month: '2-digit', year: 'numeric' })
    .replaceAll('/', '.');

  const isDayAvailable = day.shippingPossible;

  const computedStyle = [
    styles.container,
    (selected === fullDate) && styles.selected,
    !isDayAvailable && styles.disabled
  ].filter(Boolean).join(' ');

  return (
    <div
      className={computedStyle}
      onClick={() => onClick(day.dayOfShipping)}
      data-test-id="day-container"
    >
      {dayNumber === '1' &&
        <span className={styles.month} data-test-id="month">{monthShortName}</span>
      }
      <span className={styles.day} data-test-id="number">{dayNumber}</span>
      {isDayAvailable &&
        <img
          data-test-id="icon"
          src={URLS.CHECKED_CIRCLE_ICON_GREEN}
          alt={'available'}
          className={styles.indicator}
        />
      }
    </div>
  );
};

DayBox.propTypes = {
  day: PropTypes.object.isRequired,
  selected: PropTypes.string,
  onClick: PropTypes.func
};

export default DayBox;
